import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

// Modify the thunk to accept search parameters for name, startDate, and endDate
export const rewardSystemApi = createAsyncThunk("rewardSystem", async () => {
  const response = await axiosInstance.get(`/getRewards`);
  return response.data;
});

const rewardSystemSlice = createSlice({
  name: "rewardSystem",
  initialState: {
    rewardSystem: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(rewardSystemApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(rewardSystemApi.fulfilled, (state, action) => {
        state.rewardSystem = action.payload;
        state.loading = false;
      })
      .addCase(rewardSystemApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default rewardSystemSlice.reducer;
